/* RN brand v5 header: at the top of the page Ripley is the mark, frozen in flight beside the name. Scroll and he
   flies an arc over the name, brakes and lands where it ended, wing folded; now and then he looks round, preens
   under his wing or stretches. Back at the top he crouches, flies off the edge of the screen and glides back in.
   He never fades. Time-based (not scroll-scrubbed) so it reads as flight. Reduced motion: cut straight to the end state. */
(() => {
  const logo = document.querySelector('[data-rn-logo]');
  if (!logo) return;
  const bird = logo.querySelector('.rn-logo__bird'), img = bird.querySelector('img'), name = logo.querySelector('.rn-logo__name');
  const frames = img.dataset.rnFlap.split('|'), reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const P = img.dataset.rnPerch ? img.dataset.rnPerch.split('|') : []; // perch, look, preen, stretch, brake, crouch
  const FLAP = [1, 2, 3, 2], BEAT = 70, DOWN = 60, UP = 24;
  const clamp = (t, a = 0, b = 1) => Math.max(a, Math.min(b, t));
  const eio = t => -(Math.cos(Math.PI * t) - 1) / 2, eout = t => 1 - Math.pow(1 - t, 3);
  const spring = t => 1 - Math.exp(-7 * t) * Math.cos(11 * t); // settles with one soft overshoot
  const bez = (a, b, c, t) => (1 - t) * (1 - t) * a + 2 * (1 - t) * t * b + t * t * c;
  const wait = ms => new Promise(r => setTimeout(r, ms)), R = (a, b) => a + Math.random() * (b - a);
  frames.concat(P).forEach(src => { new Image().src = src; });

  let state = 'home', want = 'home', busy = false, away = false, lastScroll = 0, hold = 0;
  const show = (el, src) => { if (src && el.getAttribute('src') !== src) el.setAttribute('src', src); };
  const setFrame = (el, i) => show(el, frames[i]);
  const rest = () => state === 'flown' && P.length ? P[0] : frames[0];
  const dist = () => Math.max(0, name.offsetLeft + name.offsetWidth - bird.offsetWidth);
  const put = (x, y, r = 0, sx = 1, sy = 1) => { bird.style.transform = `translate(${x}px,${y}px) rotate(${r}deg) scale(${sx},${sy})`; };
  const wipe = cut => { name.style.clipPath = `inset(-20% 0 -20% ${clamp(cut) * 100}%)`; name.style.opacity = cut >= 1 ? 0 : 1; };
  const settle = () => {
    if (state === 'flown') { put(dist(), 0); wipe(1); logo.classList.add('is-flown'); }
    else { bird.style.transform = ''; name.style.clipPath = ''; name.style.opacity = ''; logo.classList.remove('is-flown'); }
    show(img, rest());
  };
  const run = (dur, step) => new Promise(done => {
    const t0 = performance.now();
    const tick = now => { const p = clamp((now - t0) / dur); step(p, now - t0); p < 1 ? requestAnimationFrame(tick) : done(); };
    requestAnimationFrame(tick);
  });
  const flapAt = ms => FLAP[Math.floor(ms / BEAT) % FLAP.length];

  async function flyOut() {
    const size = bird.offsetWidth, d = dist();
    logo.classList.add('is-flying');
    // Wings draw in for the first downstroke.
    await run(120, p => put(0, size * .04 * Math.sin(Math.PI * p), 0, 1 + .04 * p, 1 - .08 * Math.sin(Math.PI * p)));
    // Arc over the name, wings beating, nose following the path.
    let px = 0, py = 0;
    await run(820, (p, ms) => {
      const t = eio(p), x = bez(0, d * .42, d, t), y = bez(0, -size * 1.05, 0, t);
      const bob = Math.sin(ms / (BEAT * 4) * Math.PI * 2) * size * .05;
      const ang = clamp(Math.atan2(y - py, Math.max(.01, x - px)) * 57.3 * .7, -20, 14);
      px = x; py = y;
      put(x, y + bob, ang);
      setFrame(img, flapAt(ms));
      wipe((x + size * .6 - name.offsetLeft) / name.offsetWidth);
    });
    wipe(1);
    // Brake with wings up, feet take the weight, wing folds down.
    if (P.length) { show(img, P[4]); await run(170, p => put(d, -size * .04 * (1 - p), 4 * (1 - p))); }
    show(img, P[0] || frames[0]);
    await run(300, p => { const s = spring(p); put(d, 0, 0, 1 + .05 * (1 - s), 1 - .07 * Math.sin(Math.PI * p)); });
    logo.classList.remove('is-flying');
  }

  async function flyHome() {
    const size = bird.offsetWidth, d = dist(), left = bird.getBoundingClientRect().left - (bird.style.transform ? d : 0);
    logo.classList.add('is-flying');
    // Crouch over the feet, then launch.
    if (P.length) { show(img, P[5]); await wait(170); }
    // Off the right edge of the screen, climbing.
    const outX = innerWidth - left + size * 1.5;
    await run(620, (p, ms) => {
      const e = p * p, x = d + (outX - d) * e;
      put(x, -size * 1.6 * e + Math.sin(ms / (BEAT * 4) * Math.PI * 2) * size * .04, -14 * eout(p));
      setFrame(img, flapAt(ms));
    });
    // The name writes itself back in while he is out of sight.
    put(-left - size * 1.5, -size * .6);
    await run(360, p => { name.style.opacity = 1; name.style.clipPath = `inset(-20% ${100 - eout(p) * 100}% -20% 0)`; });
    // Glide back in from the left edge and hold the mark's pose.
    const inX = -left - size * 1.5;
    await run(640, (p, ms) => {
      const t = eout(p);
      put(inX * (1 - t), -size * .6 * (1 - t), -8 * (1 - t));
      setFrame(img, p < .7 ? flapAt(ms) : 0);
    });
    name.style.clipPath = '';
    logo.classList.remove('is-flying');
  }

  async function go() {
    if (busy) return;
    busy = true;
    stopIdle();
    while (state !== want) {
      const next = want;
      // While he is out (collecting or perched) the header just changes state; he lands wherever home is now.
      if (!reduce && !away) await (next === 'flown' ? flyOut() : flyHome());
      state = next;
      settle();
    }
    busy = false;
  }
  // Any scroll up brings him home (with the full header); scrolling down past the top sends him out again.
  let py = scrollY, upBy = 0;
  const check = () => {
    const y = scrollY, d = y - py; py = y; lastScroll = performance.now();
    // The search row folding shifts scrollY; that jump is not the reader scrolling up, so it must not call him home.
    if (performance.now() < hold) return;
    upBy = d < 0 ? upBy - d : d > 0 ? 0 : upBy;
    want = y < UP || upBy >= 10 ? 'home' : y > DOWN && d > 0 ? 'flown' : want;
    go();
  };
  addEventListener('scroll', check, { passive: true });
  addEventListener('resize', () => { if (!busy) settle(); });

  // Perched life, from the real poses (Codex motion study): look round, preen under the wing, stretch, head bob.
  // Swapped frames keep the feet in one place; only the pose changes. Without perch art he just bobs.
  const idle = async el => {
    // Reduced motion (including Windows with "Animation effects" off): no flights or bobs, but he still changes pose in place.
    if (!el) return;
    const my = (el._rnIdle = (el._rnIdle || 0) + 1), ok = () => el._rnIdle === my, k = Math.random();
    const bob = () => el.animate([{ transform: 'none' }, { transform: 'translateY(3%) scale(1.02,.97)' }, { transform: 'none' }], { duration: 260, easing: 'ease-in-out' }).finished.catch(() => {});
    if (!P.length || k > .85) { if (reduce) return; await bob(); await wait(R(300, 600)); if (ok()) await bob(); return; }
    if (k < .35) { show(el, P[1]); await wait(R(900, 1600)); }
    else if (k < .7) { show(el, P[1]); await wait(150); if (!ok()) return; show(el, P[2]); await wait(R(900, 1500)); if (!ok()) return; show(el, P[1]); await wait(180); }
    else { show(el, P[3]); await wait(R(550, 800)); }
    if (ok()) show(el, P[0]);
  };
  function stopIdle() { img._rnIdle = (img._rnIdle || 0) + 1; img.getAnimations().forEach(a => a.cancel()); show(img, rest()); }
  // Only a perched bird idles; the mark at the top stays still.
  const idleLoop = first => setTimeout(async () => {
    const r = bird.getBoundingClientRect();
    if (state === 'flown' && !busy && !away && !document.hidden && performance.now() - lastScroll > 1500 && r.bottom > 0 && r.top < innerHeight) await idle(img);
    idleLoop(false);
  }, first ? 3000 : R(5000, 10000));
  idleLoop(true);

  // Other scripts borrow Ripley: he leaves the header while he is flying about the page and comes back to land.
  window.rnRipley = {
    rect: () => bird.getBoundingClientRect(),
    frames, idle,
    isAway: () => away,
    isBusy: () => busy,
    leave() { stopIdle(); away = true; logo.classList.add('is-away'); },
    land() {
      away = false; logo.classList.remove('is-away');
      if (busy) return;
      settle(); go();
      if (!reduce) img.animate([{ transform: 'scale(1.06,.92)' }, { transform: 'none' }], { duration: 260, easing: 'cubic-bezier(.3,1.5,.5,1)' });
    }
  };

  // Phones: the logo row (bird, basket) always stays; only the search row folds away while reading down and returns on scroll up.
  const phone = matchMedia('(max-width: 749px)');
  // Folding changes the header's height, so the browser shifts scrollY by that much; ignore those shifts or it re-folds itself.
  let lastY = scrollY;
  addEventListener('scroll', () => {
    const y = scrollY, d = y - lastY;
    if (performance.now() < hold) { lastY = y; return; }
    if (Math.abs(d) < 8 && y > 150) return;
    const fold = phone.matches && y > 150 && d > 0, on = document.body.classList.contains('rn-search-folded');
    if ((fold || d < 0 || y <= 150) && fold !== on) { document.body.classList.toggle('rn-search-folded', fold); hold = performance.now() + 400; }
    lastY = y;
  }, { passive: true });

  (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => { state = want = scrollY > DOWN ? 'flown' : 'home'; settle(); });
})();
